'use client';

import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';

// Exposes the already-initialised client (see instrumentation-client.ts) to the
// React tree via usePostHog(). Init does NOT happen here — that would re-run on
// Strict-Mode double-mount. This only passes the singleton through.
export const PostHogProvider = ({ children }: { children: React.ReactNode }) => {
  return <PHProvider client={posthog}>{children}</PHProvider>;
};
